export default "__VITE_ASSET__Cvouv0MO__"